/*
 Copyright (C) 2022-present Wong Chun Yat (wcyat)

 This program is free software: you can redistribute it and/or modify
 it under the terms of the GNU Affero General Public License as
 published by the Free Software Foundation, either version 3 of the
 License, or (at your option) any later version.

 This program is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Affero General Public License for more details.

 You should have received a copy of the GNU Affero General Public License
 along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { useNotification } from "../components/AppContextProvider";

export function Notification() {
    const [notification, setNotification] = useNotification();

    return (
        <Snackbar
            className="rounded-[8px]"
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            open={notification.open}
            autoHideDuration={3000}
            onClick={() => {
                setNotification({ ...notification, open: false });
            }}
            onClose={() => {
                setNotification({ ...notification, open: false });
            }}
        >
            <Alert
                onClose={() => {
                    setNotification({ ...notification, open: false });
                }}
                severity={notification.severity || "info"}
                className="rounded-[8px] w-[300px]"
            >
                {notification.text}
            </Alert>
        </Snackbar>
    );
}
